import React from "react";

import PretendardText from "../atoms/text/pretendardText";

function Empty({ style }) {
  return (
    <>
      <div
        style={{
          height: "300px",
          background: "transparent",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 1044,
          borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
          ...style,
        }}
      >
        <PretendardText
          style={{
            fontSize: "15px",
            fontWeight: "400",
            lineHeight: "22px",
            color: "#aaa",
          }}
        >
          데이터가 없습니다.
        </PretendardText>
      </div>
    </>
  );
}

export default Empty;
